import { Box, Typography } from "@mui/material";
import SocialMediaComponent from "./social-media";
import { brandingColors } from "../utils";
import "./reduced-footer.css";

export default function ReducedFooterComponent(): JSX.Element {
  return (
    <Box className="reduced-footer"
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between"
        }}
    >
        <Box className="container"
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          <Box className="wrapper">
            <Box
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: { xs: "row", md: "row" },
                justifyContent: "space-between",
                color: brandingColors["green-font"],
              }}
            >
              <Box
                sx={{
                  padding: "10px 20px",
                  width: "50%",
                  borderRadius: "10px",
                }}
              >
                <SocialMediaComponent />
              </Box>
              <Box
                sx={{
                  padding: "10px 20px",
                  width: "50%",
                  borderRadius: "10px",
                }}
              >
                <Box>
                  <Typography variant={"subtitle2"}>
                    We are the first AI-powered beauty recommandation platform
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
    </Box>
  )
}